import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app';
import { BlobUploadResponse } from 'src/app/model';
import { DtcServiceService } from 'src/app/modules/dtc/dtc-service.service';

@Component({
  selector: 'app-entity-bulk-upload',
  templateUrl: './entity-bulk-upload.component.html',
  styleUrl: './entity-bulk-upload.component.css'
})
export class EntityBulkUploadComponent implements OnInit, OnDestroy {

  //File Upload
  fileName = new FormControl();
  file = new FormControl();
  public fileContent: any;
  fileMimeTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ];
  maxFileSize: number;
  public selectedFileUrls: { name: string, url: string, id?: string }[] = [];
  fileError: boolean = false;

  //DownloadInventory
  downloadSubscription: Subscription;
  uploadSubscription: Subscription;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _dialogRef: MatDialogRef<any>, private _dtcService: DtcServiceService, private _sharedService: ServicecallService) { }

  ngOnInit(): any {

  }

  ngOnDestroy(): any {
    this.downloadSubscription?.unsubscribe();
    this.uploadSubscription?.unsubscribe();
  }

  closeDialog() {
    this._dialogRef?.close();
  }

  /**
   * Downloads inventory
   */
  downloadInventory() {
    this.downloadSubscription = this._dtcService.inventoryDownload(this.data?.inventoryApiType)?.subscribe(
      {
        next: (response: any) => {
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(response);
          a.href = url;
          a.download = 'Inventory.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        }, error: () => {
          this._sharedService?.toasterService({ type: 'error', msg: 'Unable to download Inventory' })
        }
      }
    );
  }

  /**
   * Bulk upload entity data
   */
  bulkUpload() {
    if(this.file.value?.type !== "application/vnd.ms-excel" && this.file.value?.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      this.fileError = true;
      return;
    } else {
      this.fileError = false;
      const formData = new FormData();
      formData.append('avatar', this.file?.value);
      this._sharedService.commonExport('csv', formData, this.data?.apiType, 'Uploaded data_', null, null, null, 'bulk-upload')
      this._dialogRef?.close();
      // this.uploadSubscription = this._dtcService.bulkUpload(formData,this.data?.apiType)?.subscribe(
      //   {
      //     next: (response: any) => {
      //       const a = document.createElement('a');
      //       const url = window.URL.createObjectURL(response);
      //       a.href = url;
      //       a.download = 'Uploaded file.xlsx';
      //       document.body.appendChild(a);
      //       a.click();
      //       a.remove();
      //       window.URL.revokeObjectURL(url);
      //       // if(response?.notExistingDoc?.length) {
      //       //   this._sharedService?.toasterService({ type: 'warning', msg: `Created: ${response?.created}, Updated: ${response?.updated}, Failed: ${response?.notExistingDoc?.length}`, title: 'Partially Updated' });
      //       // } else {
      //       //   this._sharedService?.toasterService({ type: 'success', msg: `Created: ${response?.created}, Updated: ${response?.updated}`, title: 'Success' });
      //       // }
      //       this._dialogRef?.close();
      //     }, error: () => {
      //       this._sharedService?.toasterService({ type: 'error', msg: 'Unable to Upload' });
      //       this._dialogRef?.close();
      //     }
      //   }
      // );
    }
  }

  /**
   * Uploads response
   * @param event
   * @param formControlName
   */
  uploadResponse(event: Partial<BlobUploadResponse>, formControlName: string) {
    if (event?.stage === 'soft-delete') {
      this.fileError = false;
    }
  }

}
